import React,{useState,useEffect} from "react";
import { Link } from "react-router-dom";
import AddCondidateModel from "./AddCandidateModel"
import Paginate from "../../../CommanCom/Pagination";
import Loader from "../../../CommanCom/Loader";
import {getNewCondidateList} from "../../../Redux/Actions/newJoinerAction";
import { useDispatch,useSelector } from "react-redux";
import {sendjoiningFrom} from './api/Calls'
import moment from "moment";
import ConfirmationAlert from "./ConfirmationModel";


const Table = () => {
    const dispatch = useDispatch();
    const { condidate,loading } = useSelector((state) => state.NewJoinerReducer);
    const [currentPage, setCurrentPage] = useState(1);
    const [selected,setSelelected] = useState('');
    const [mailForm,setMailForm] = useState('');
    const [alertPopup,setAlertPopup] = useState('');

    useEffect(() =>{
        dispatch(getNewCondidateList());
    },[])
    const handleUpdate = (candidateItems) =>{
        setSelelected(candidateItems);
    }
    
    const postPerPage = 10;
    const totalPosts = condidate?.length;

    const indexOfLastPost = currentPage * postPerPage;
    const indexOfFirstPost = indexOfLastPost - postPerPage;
    const filterNewCondidate = condidate?.slice(indexOfFirstPost, indexOfLastPost);
    console.log(filterNewCondidate)
    const sendJoiningFormHandler = (condidateID)=>{
        //console.log(condidateID)
        sendjoiningFrom(condidateID).then((data) =>{
            console.log('joining')
            console.log(data)
            if(data.status){
                setMailForm(1);
            }else{
                setMailForm(0);
            }
            
        })
    }
    const openConfirmationAlert = (id) =>{
        setAlertPopup(id)
    }
    return (
        <>
            <AddCondidateModel condidateDetail={selected} setSelelected={setSelelected} />
            <ConfirmationAlert sendJoiningFormHandler={sendJoiningFormHandler} alertPopup={alertPopup} />
            <div className="row_bg">
                <div className="row mb30">
                    <div className="col-md-12">
                        <table className="table_style_1">
                            <thead>
                                <tr>
                                    <th>Sr.No</th>
                                    <th>Candidate Name</th>
                                    <th>Personal Email</th>
                                    <th>Contact Number	</th>
                                    <th>Date of Joining</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            {loading ? (
                            <Loader />
                        ) : (
                            <tbody>
                            {
                                filterNewCondidate?.length > 0 ?
                                filterNewCondidate?.map((item, keys) => {
                                    var warningClass = '';
                                    var statusText = '';
                                    if(item.onboarding_status == 0){
                                         warningClass = 'bg-danger';
                                         statusText = 'pending';
                                    }else if(item.onboarding_status == 1){
                                         warningClass = 'bg-success';
                                         statusText = 'request Sent';
                                    }else if(item.onboarding_status == 2){
                                        warningClass = 'bg-success';
                                        statusText = 'Inprogress';
                                    }else if(item.onboarding_status == 3){
                                        warningClass = 'bg-warning';
                                        statusText = 'HR Review';
                                    }
                                    return (
                                        <tr key={keys}>
                                            <td>{keys + 1}</td>
                                            <td><span className="avatar_icon">{item.first_name ? item.first_name.match(/(\b\S)?/g).join("").match(/(^\S|\S$)?/g).join("").toUpperCase() : ''}</span> {item.first_name}</td>
                                            <td>{item.personal_email}</td>
                                            <td>{item.contact_no}</td>
                                            <td>{moment(item.joining_date).format('DD-MM-YYYY')}</td>
                                            <td>
                                               
                                                <span className={`badge ${warningClass}`}>{statusText}</span></td>
                                            <td>
                                            <button
                                                className="btn_7 mr03"
                                                data-bs-toggle="modal"
                                                data-bs-target="#addcandidate"
                                                onClick={() => handleUpdate(item)}
                                            >
                                                Edit
                                            </button>
                                            <button className="btn_7 mr03" data-bs-toggle="modal" data-bs-target="#confirm_alert" onClick={() => openConfirmationAlert(item.condidateID)} >Join Us</button>
                                            </td>
                                        </tr>
                                    )})
                                :
                                <tr>
                                    <td colSpan={6} className="text-center">
                                        <div className="notfound">No Record found</div>
                                    </td>
                                </tr>
                            }
                            </tbody>
                        )}
                        {filterNewCondidate?.length > 0 ? 
                        <tfoot>
                            <tr>
                                <td colSpan={6}>
                                    {totalPosts > postPerPage &&  (
                                        <Paginate
                                            currentPage={currentPage}
                                            setCurrentPage={setCurrentPage}
                                            totalPosts={totalPosts}
                                            postPerPage={postPerPage}
                                        />
                                    )}
                                </td>
                            </tr>
                            
                        </tfoot>
                        :''}
                        </table>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Table;